module.exports = __webpack_public_path__ + "static/media/features1b@2x.fe3a9a58.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/features1b@2x.png
 ** module id = 899
 ** module chunks = 0
 **/